import React from "react"
import styled from "styled-components"
import { Paragraph } from "buoy-core"
import { fontSize } from "buoy-theme"
// Because of existing breakpoints for the ChatList we want to use the old styledhelpers for now.
import { responsive } from "../../common/styledHelpers"

// KAN-4851 revisit

const DisclaimerParagraph = styled(Paragraph)`
  ${fontSize("bodySmall")};
  ${responsive("margin", "48px 0 -14px", "20px 0 0")};
`

const Disclaimer = ({ disclaimer }) =>
  disclaimer ? <DisclaimerParagraph>{disclaimer}</DisclaimerParagraph> : null

export { Disclaimer as default }



// WEBPACK FOOTER //
// ./assets/interview/components/Disclaimer.js